export default function popIngredients() {
	const outerPop = document.querySelector('.mobile-ingreients-pop')
	const innerPop = document.querySelectorAll('.mobile-ingreients-pop__el')
	const innerPopClose = document.querySelectorAll(
		'.mobile-ingreients-pop__close'
	)
	const tipPop = document.querySelectorAll('.tippy')

	const pop = (el) => {
		outerPop.classList.toggle('active')
		// innerPop.classList.toggle('active')
		let tipTarget = el.target.dataset.template

		innerPop.forEach((item) => {
			if (item.dataset.target == tipTarget) {
				item.classList.add('active')
			} else {
				item.classList.remove('active')
			}
		})
	}

	tipPop.forEach((item) => {
		item.addEventListener('click', pop)
	})

	innerPopClose.forEach((item) => {
		item.addEventListener('click', () => {
			outerPop.classList.remove('active')
			innerPop.forEach((item) => {
				item.classList.remove('active')
			})
		})
	})
}
